import { render } from "./ResponsiveLayout.vue?vue&type=template&id=3a47a3cc&scoped=true&ts=true"
import script from "./ResponsiveLayout.vue?vue&type=script&lang=ts"
export * from "./ResponsiveLayout.vue?vue&type=script&lang=ts"

import "./ResponsiveLayout.vue?vue&type=style&index=0&id=3a47a3cc&lang=scss&scoped=true"

import exportComponent from "C:\\NEW DTC 2021\\ecpv\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a47a3cc"]])

export default __exports__